import { useHotkeys, Options, HotkeyCallback } from "react-hotkeys-hook";
import { usePostHog } from "posthog-js/react";

export function useTrackedHotkeys(
  keys: string,
  callback: HotkeyCallback,
  options?: Options
) {
  const posthog = usePostHog();

  const wrappedCallback: HotkeyCallback = (event, handler) => {
    posthog.capture("hotkey_pressed", {
      keys: keys,
    });

    callback(event, handler);
  };

  return useHotkeys(keys, wrappedCallback, options);
}
